import { Icon, Tooltip } from '@orbita-ui/core';
import { HeaderButton } from '../AppHeader/AppHeader.styles';
import { useAuth } from 'auth/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'user/routes';

export const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const logoutHandler = () => {
    logout();
    navigate(LOGIN_PATH);
  };

  return (
    <HeaderButton onClick={() => logoutHandler()}>
      <Tooltip position="left" text="Cerrar Sesión">
        <Icon name="LogOutIcon" />
      </Tooltip>
    </HeaderButton>
  );
};
